import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Divider from "@mui/material/Divider";
import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useNavigate, useLocation } from "react-router-dom";
import { grey } from "@mui/material/colors";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ tabs: { "&.MuiTabs-root": { minHeight: "2rem" }, "& .MuiTab-root": { minWidth: "0", minHeight: "0", padding: theme.spacing(1), paddingLeft: theme.spacing(3), paddingRight: theme.spacing(3), fontSize: "0.8rem", "&.Mui-disabled": { color: grey["400"] } } }, right: { flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: theme.spacing(1) } }); });
export function useCurrentTab() { var location = useLocation(); var search = new URLSearchParams(location.search); return search.get("t"); }
export function TTabs(props) {
    var _props$values$find;
    var styles = useStyles().classes;
    var nav = useNavigate();
    var location = useLocation();
    var search = new URLSearchParams(location.search);
    var t = search.get("t");
    var _a = useState(t), tab = _a[0], setTab = _a[1];
    var onChange = props.onChange;
    useEffect(function () {
        if (!t) {
            if (props.values.length === 0)
                return;
            var search_1 = new URLSearchParams(location.search);
            search_1.set("t", props.values[0].name); // use replace so people can navigate backwards without
            // being stuck in redirection
            nav({ pathname: location.pathname, search: search_1.toString() }, { replace: true });
            return;
        }
        setTab(t);
        onChange(t);
    }, [t, onChange, nav, location.search, location.pathname, props.values]);
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsxs(Tabs, { value: tab || ((_props$values$find = props.values.find(function (v) { return true; })) === null || _props$values$find === void 0 ? void 0 : _props$values$find.name) || "-", onChange: function (e, v) {
                    if (v === undefined)
                        return; // from text inputs in props.rightAction
                    search.set("t", v);
                    nav({ pathname: location.pathname, search: search.toString() });
                }, className: styles.tabs, children: [props.values.map(function (v) { /*#__PURE__*/ return _jsx(Tab, { value: v.name, label: "label" in v ? v.label : v.name, disabled: v.disabled }, v.name); }), /*#__PURE__*/ _jsx("div", { className: styles.right, children: /*#__PURE__*/ _jsx("div", { children: props.rightAction }) })] }), /*#__PURE__*/ _jsx(Divider, {})] });
}
